export enum DomainSuggestionType {
    Premium = 'premium',
    Suggestion = 'suggestion',
}
